import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import TokenService from 'src/services/TokenService';

interface PublicRouteProps {
  children: ReactNode;
}

export const PublicRoute: FC<PublicRouteProps> = ({ children }) => {
  const user = TokenService.getUser();

  if (user?.access) {
    return <Navigate to={`/map${window.location.search || ''}`} />;
  }

  return <>{children}</>;
};
